import { parseDataAttributes } from '../../utilities/utilities'
import type { TypographyConfig, ButtonConfig } from '../../types/widget-types'

export type CartConfigStyles = {
  addToCartButtonVariant: ButtonConfig
  productNameTypography: TypographyConfig
  priceTypography: TypographyConfig
  listPriceTypography: TypographyConfig
  quantityTypography: TypographyConfig
}

export type CartAttributes = {
  showImage?: boolean
  showPrice?: boolean
  showAddToCartButton?: boolean
  showRemoveButton?: boolean
  showQuantityText?: boolean
  configStyles?: CartConfigStyles
}

export function getCartAttributes(attrs: NamedNodeMap): CartAttributes {
  const base = parseDataAttributes(attrs) as Record<string, unknown>

  const showImage = base.showImage === 'yes' || base.showImage === true
  const showPrice = base.showPrice === 'yes' || base.showPrice === true
  const showAddToCartButton =
    base.showAddToCartButton === 'yes' || base.showAddToCartButton === true
  const showRemoveButton = base.showRemoveButton === 'yes' || base.showRemoveButton === true
  const showQuantityText = base.showQuantityText === 'yes' || base.showQuantityText === true

  return {
    showImage,
    showPrice,
    showAddToCartButton,
    showRemoveButton,
    showQuantityText,
    configStyles: base.configStyles as CartConfigStyles | undefined,
  }
}

export default function propsFn(dataAttributes: NamedNodeMap): CartAttributes {
  return getCartAttributes(dataAttributes)
}
